import { render, staticRenderFns } from "./addModal.vue?vue&type=template&id=a1d48418&"
import script from "./addModal.vue?vue&type=script&lang=js&"
export * from "./addModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports